<template>
  <div>
    <!--school-->
    <K2Row class="mb-2 flex-wrap" style="cursor: pointer" v-if="isSchool">
      <div class="mb-2">
        <span class="box error d-flex text-white px-2 py-0 rounded-pill me-2">{{ currentSchool }}</span>
      </div>
    </K2Row>
    <!--    class-->
    <K2Row class="mb-2 flex-wrap" style="cursor: pointer" v-if="classList && classList.length">
      <div v-for="(classes, i) of classList" :key="classes.Str_ID" class="mb-2">
        <div v-if="i < 3 && !classShow">
          <span v-if="classes.PostTagClassName.length < 12" class="box yellow px-2 py-1 rounded-pill me-2">{{
            classes.PostTagClassName + ' ' + classes.PostTagClassBatch
          }}</span>
          <span v-else class="box yellow px-2 py-1 rounded-pill me-2">{{ classes.PostTagClassName.substring(0, 12) + '..' }}</span>
        </div>
        <div v-else-if="classShow">
          <span class="box yellow px-2 py-1 rounded-pill me-2">{{ classes.PostTagClassName }}</span>
        </div>
      </div>
      <div @click="controlMore('class')" v-if="classList.length > 3">
        <span class="tag px-2 py-1 rounded-pill me-2" v-if="!classShow">More..</span>
        <span class="tag px-2 py-1 rounded-pill me-2" v-if="classShow">Show Less..</span>
      </div>
    </K2Row>
    <!--    level-->
    <K2Row class="mb-2 flex-wrap" style="cursor: pointer" v-if="levelList && levelList.length">
      <div v-for="(level, i) of levelList" :key="level.Str_ID" class="mb-2">
        <div v-if="i < 3 && !levelShow">
          <span v-if="level.PostTagLevelName.length < 12" class="box blue px-2 py-1 rounded-pill me-2">{{ level.PostTagLevelName }}</span>
          <span v-else class="box blue px-2 py-1 rounded-pill me-2">{{ level.PostTagLevelName.substring(0, 12) + '..' }}</span>
        </div>
        <div v-else-if="levelShow">
          <span class="box blue px-2 py-1 rounded-pill me-2">{{ level.PostTagLevelName }}</span>
        </div>
      </div>
      <div @click="controlMore('class')" v-if="levelList.length > 3">
        <span class="box blue px-2 py-1 rounded-pill me-2" v-if="!levelShow">More..</span>
        <span class="box blue px-2 py-1 rounded-pill me-2" v-if="levelShow">Show Less..</span>
      </div>
    </K2Row>
    <!--    student-->
    <K2Row class="mb-2 flex-wrap" style="cursor: pointer" v-if="studentList && studentList.length">
      <div v-for="(student, i) of studentList" :key="student.Student_ID" class="mb-2">
        <div v-if="student.StudentName">
          <div v-if="i < 3 && !upHere">
            <span v-if="student.length < 8" class="tag px-2 py-1 rounded-pill me-2">{{ student.StudentName }}</span>
            <span v-else class="tag px-2 py-1 rounded-pill me-2">{{ student.StudentName.substring(0, 8) + '..' }}</span>
          </div>
          <div v-else-if="upHere">
            <span class="tag px-2 py-1 rounded-pill me-2">{{ student.StudentName }}</span>
          </div>
        </div>
      </div>
      <!--            <div @click="controlMore('student')" v-if="studentList.length>3">-->
      <!--                <span class="tagButton px-2 py-1 rounded-pill me-2" v-if="!upHere">More..</span>-->
      <!--                <span class="tagButton px-2 py-1 rounded-pill me-2" v-if="upHere">Show Less..</span>-->
      <!--            </div>-->
    </K2Row>
  </div>
</template>
<script>
import DataSource from '../../../data/datasource'
import { lang } from '../../../locale/index'
import moment from 'moment'
import $ from 'jquery'
import Vue from 'vue'
import assets from '../../../assets/assets'
import K2Row from '../../../uiComponents/k2Row/k2Row'
import Cookies from 'js-cookie'

export default {
  name: 'feedStudents',
  components: { K2Row },
  data() {
    return {
      assets: assets,
      upHere: false,
      classShow: false,
      levelShow: false,
      studentList: [],
      ddlClassList: [],
      classList: [],
      levelList: [],
      currentSchool: null,
      isSchool: false,
      fetchStudent: [],
    }
  },
  created() {},
  mounted() {
    this.currentSchool = Cookies.get('userSchoolNameSession')
    this.fetchPostSelectedTag()
  },
  watch: {
    passPostTagLists: function (value) {
      // watch it
      if (value) {
        this.fetchPostSelectedTag()
      }
    },
  },
  props: ['parentPost', 'passstudentList', 'handleSelectedTags', 'setLoad', 'passPostTagLists'],
  methods: {
    async fetchPostSelectedTag() {
      this.$emit('setLoad', true)
      // const response = await DataSource.shared.getPostTagListByPostID(this.parentPost.PostID)
      if (this.passPostTagLists) {
        this.isSchool = this.passPostTagLists.find(d => d.IsAllLevel === true)
        if (!this.isSchool) {
          if (this.passPostTagLists[0].PostTagClassID) {
            this.classList = this.passPostTagLists
            this.$emit('handleSelectedTags', this.classList, 'class')
          } else if (this.passPostTagLists[0].PostTagLevelID) {
            this.levelList = this.passPostTagLists
            this.$emit('handleSelectedTags', this.levelList, 'level')
          } else if (this.passPostTagLists[0].PostTagUserID) {
            this.studentList = this.passPostTagLists
            this.$emit('handleSelectedTags', this.studentList, 'student')
          }
        } else {
          this.$emit('handleSelectedTags', this.currentSchool, 'school')
        }
      }
      this.$emit('setLoad', false)
    },
    isNull(obj) {
      return obj === null || obj === undefined || obj === 'undefined' || obj.length === 0 || obj === ''
    },
    // async sortByLevelClass() {
    //   try {
    //     const result = await DataSource.shared.getAllActiveStudentsBySchoolWithMode('ProfileImagePhysicalPath')
    //     if (result) {
    //       if (result.code === '88') {
    //         window.location.replace('/');
    //         console.log('88');
    //         return;
    //       }
    //       if (this.isNull(result.Table)) {
    //         return;
    //       }
    //       this.groupStudentList(result.Table);
    //     }
    //   } catch (e) {
    //     console.log("sortByLevelClass err", e)
    //   }
    // },
    // groupStudentList(result) {
    //   let classList = []
    //   let levelList = []
    //   let sortedList = this.groupBy(result, "SMT_Code", "SMT_Code");
    //   for (let i = 0; i < sortedList.length; i++) {
    //     let tempLevel = this.groupBy(sortedList[i].ArrObj_Items, "CRS_Course_Name", "CRS_Course_Name", "PK_Course_ID");
    //     for (let j = 0; j < tempLevel.length; j++) {
    //       let tempClass = this.groupBy(tempLevel[j].ArrObj_Items, "CLS_ClassName", "CLS_ClassName", "PK_Class_ID");
    //       tempLevel[j].ArrObj_Items = tempClass;
    //     }
    //     sortedList[i].ArrObj_Items = tempLevel;
    //   }
    //   sortedList.forEach(d => {
    //     d.ArrObj_Items.forEach(m => {
    //       levelList.push(m)
    //       m.ArrObj_Items.forEach(e => {
    //         classList.push(e)
    //       })
    //     })
    //   })
    //   this.ddlClassList = classList
    //   this.ddlLevelList = levelList
    //   this.fetchPostSelectedTag()
    //
    // },
    // groupBy(data, key, display, id) {
    //   let ArrObj_Sorted = [];
    //   let arrstr_display = !this.isNull(display) ? display.split(",") : [key];
    //   for (let item of data) {
    //     let index = ArrObj_Sorted.findIndex(x => x.Str_SortBy === item[key]);
    //     if (index === -1) {
    //       let str_Display = "";
    //       for (let tempdisp of arrstr_display)
    //         str_Display += item[tempdisp] + " ";
    //       ArrObj_Sorted.push({Str_SortBy: item[key], Str_Display: str_Display, Str_ID: item[id], ArrObj_Items: [item]});
    //     } else
    //       ArrObj_Sorted[index].ArrObj_Items.push(item);
    //   }
    //   return ArrObj_Sorted;
    // },
    controlMore(type) {
      switch (type) {
        case 'student':
          this.upHere = !this.upHere
          break
        case 'class':
          this.classShow = !this.classShow
          break
      }
    },
    checkArray(list) {
      return Array.isArray(list)
    },
    // async handleStudent(students) {
    //     if (this.fetchStudent && this.fetchStudent.length < 1) {
    //         this.fetchStudent = students;
    //         console.log(students, "students");
    //         if (students) {
    //             this.studentList = studentList;
    //             this.$emit("handleSelectedTags", this.studentList, "student");
    //         }
    //     }
    // },
    // handleClassList(classes) {
    //     if (classes) {
    //         this.ddlClassList.forEach(m => {
    //             classes.forEach(d => {
    //                 if (d.PostTagClassID && m.Str_ID) {
    //                     if (d.PostTagClassID === m.Str_ID) {
    //                         const exist = this.classList.find(x => x.Str_ID === m.Str_ID);
    //                         if (!exist) {
    //                             this.classList.push(m);
    //                         }
    //                     }
    //                 }
    //             });
    //
    //         });
    //         this.$emit("handleSelectedTags", this.classList, "class");
    //
    //     }
    // },
    // handleLevelList(level) {
    //     if (level) {
    //         this.ddlLevelList.forEach(m => {
    //             level.forEach(d => {
    //                 if (d.PostTagLevelID && m.Str_ID) {
    //                     if (d.PostTagLevelID === m.Str_ID) {
    //                         const exist = this.levelList.find(x => x.Str_ID === m.Str_ID);
    //                         if (!exist) {
    //                             this.levelList.push(m);
    //                         }
    //                     }
    //                 }
    //             });
    //
    //         });
    //         this.$emit("handleSelectedTags", this.levelList, "level");
    //     }
    // }
  },
}
</script>
